// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adsBanner_banner__2ipTa {\n  margin-top: 5px;\n  margin-right: 6px;\n}\n.adsBanner_banner__2ipTa .adsBanner_content__RNYoq {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.496065);\n  height: 50px;\n  width: 320px;\n  background: rgba(255, 255, 255, 0.25);\n  border: 1px solid #ffffff;\n  margin-bottom: -14px;\n}\n.adsBanner_banner__2ipTa .adsBanner_warning__1QvaZ {\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 8px;\n  color: rgba(255, 255, 255, 0.496065);\n}", ""]);
// Exports
exports.locals = {
	"banner": "adsBanner_banner__2ipTa",
	"content": "adsBanner_content__RNYoq",
	"warning": "adsBanner_warning__1QvaZ"
};
module.exports = exports;
